module.exports = __webpack_public_path__ + "static/media/Mouth_4.f99805d9.jpg";